import { FiltersDropdown } from "reusableComponents";
import styles from "./styles.module.scss";
import { iconKWhite } from "assets/icons";
import { useTranslation } from "react-i18next";

const PackCard = ({ pack, onActivate }) => {
  const { t } = useTranslation("global");

  return (
    <div
      className={`${styles.item} ${styles.packItem} ${
        pack.disabled ? styles.disabled : ""
      }`}
    >
      <img
        alt="option"
        className={styles.image}
        src={pack.image_url.replace(/\\\//g, "/")}
      />
      <div className={styles.content}>
        <h4 className={styles.packTitle}>{pack.name}</h4>
        <span className={styles.description}>{pack.description}</span>

        <div className={styles.packOptions}>
          {pack.options?.map((opt) => (
            <img
              key={opt.id}
              alt="pack option"
              className={styles.packOptionImg}
              src={opt.image_url}
            />
          ))}
        </div>

        <span className={styles.percentage}>
                    {`${t("provide.step4.options.commissionRate", {
                      value: pack.percentage,
                    })} ${t("provide.step4.options.weeks", {
                      weeks: pack.duration / 7,
                    })}`}
                  </span>

        <div className={styles.dropdownWrapper}>
          <FiltersDropdown
            selected={pack.active}
            options={[
              { label: "Active", value: true },
              { label: "Inactive", value: false },
            ]}
            onSelect={(value) => onActivate(pack.id,value )}
          />
          <img
            src={iconKWhite}
            alt="status icon"
            className={`${styles.statusIcon} ${
              styles[pack.active ? "activeIcon" : "inActiveIcon"]
            }`}
          />
        </div>
      </div>
    </div>
  );
};

export default PackCard;
